import { UseQueryResult } from "@tanstack/react-query";
import React, { PropsWithChildren } from "react";

import { GetReportByIdQuery } from "@api/graphql/types-and-hooks";
import { MissingReportPage } from "@pages/AssessmentReportV2Details/MissingReportPage";
import { ReportFallback } from "@providers/ReportProvider/ReportFallback";
import { ReportContext, ReportNode, ReportViewMode } from "@providers/ReportProvider/context";

interface ReportProviderProps {
  report: ReportNode | undefined;
  reportQuery: UseQueryResult<GetReportByIdQuery, unknown>;
  viewMode: ReportViewMode;
  fallback?: React.ReactNode;
}

export const ReportProvider: React.FC<PropsWithChildren<ReportProviderProps>> = ({
  report,
  reportQuery,
  viewMode,
  fallback,
  children,
}) => {
  if (!report && fallback) return fallback;

  if (!report) {
    if (reportQuery.isLoading) return <ReportFallback />;

    return <MissingReportPage />;
  }

  return <ReportContext.Provider value={{ report, reportQuery, viewMode }}>{children}</ReportContext.Provider>;
};
